import { render, staticRenderFns } from "./benefitsList.vue?vue&type=template&id=9b6f1fc4"
import script from "./benefitsList.vue?vue&type=script&lang=js"
export * from "./benefitsList.vue?vue&type=script&lang=js"
import style0 from "./benefitsList.vue?vue&type=style&index=0&id=9b6f1fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports